//custom style
const data = {
  style: {
    up: "#18eed8",
    down: "#ff0a42",
    //     bg: "#1d1d29",
    //     grid: "#1e2235",
    //     cross: "#9194A3",
    //     border: "#4e5b85",
    //     borderUpColor: "rgba(21,195,34,0.9)",
    //     borderDownColor: "rgba(255, 15, 93,0.9)",
    //     text: "#61688A",
    //     areatop: "rgba(122, 152, 247, .2)",
    //     areadown: "rgba(122, 152, 247, .02)",
  },
  obj: function () {
    return {
      "paneProperties.background": "#1e1f23", //candle style
      // candlestick style
      "mainSeriesProperties.candleStyle.upColor": this.style.up,
      "mainSeriesProperties.candleStyle.downColor": this.style.down,
      "mainSeriesProperties.candleStyle.drawWick": true,
      "mainSeriesProperties.candleStyle.drawBorder": false,
      "mainSeriesProperties.candleStyle.wickUpColor": this.style.up,
      "mainSeriesProperties.candleStyle.wickDownColor": this.style.down,
      "mainSeriesProperties.candleStyle.borderUpColor": this.style.up,
      "mainSeriesProperties.candleStyle.borderDownColor": this.style.down,
      "mainSeriesProperties.showPriceLine": true,
      "paneProperties.vertGridProperties.style": 0,
      "paneProperties.horzGridProperties.color": "#1e1f23",
      "paneProperties.vertGridProperties.color": "#1e1f23",
      "scalesProperties.lineColor": "#262627",
      "scalesProperties.textColor": "#888989",
      "scalesProperties.fontSize": 11,

      // Hollow candlestick style
      "mainSeriesProperties.hollowCandleStyle.upColor": this.style.up,
      "mainSeriesProperties.hollowCandleStyle.downColor": this.style.down,
      "mainSeriesProperties.hollowCandleStyle.drawWick": true,
      "mainSeriesProperties.hollowCandleStyle.drawBorder": true,
      "mainSeriesProperties.hollowCandleStyle.wickUpColor": this.style.up,
      "mainSeriesProperties.hollowCandleStyle.wickDownColor": this.style.down,
      "mainSeriesProperties.hollowCandleStyle.borderUpColor": this.style.up,
      "mainSeriesProperties.hollowCandleStyle.borderDownColor": this.style.down,

      // Average candlestick style
      "mainSeriesProperties.haStyle.upColor": this.style.up,
      "mainSeriesProperties.haStyle.downColor": this.style.down,
      "mainSeriesProperties.haStyle.drawWick": true,
      "mainSeriesProperties.haStyle.drawBorder": false,
      "mainSeriesProperties.haStyle.wickUpColor": this.style.up,
      "mainSeriesProperties.haStyle.wickDownColor": this.style.down,
      "mainSeriesProperties.haStyle.borderUpColor": this.style.up,
      "mainSeriesProperties.haStyle.borderDownColor": this.style.down,

      // American line style
      "mainSeriesProperties.barStyle.upColor": this.style.up,
      "mainSeriesProperties.barStyle.downColor": this.style.down,
      "mainSeriesProperties.barStyle.barColorsOnPrevClose": false,
      "mainSeriesProperties.barStyle.dontDrawOpen": false,

      // Line chart style
      "mainSeriesProperties.lineStyle.color": "#2296f3",
      "mainSeriesProperties.lineStyle.linestyle": 0,
      "mainSeriesProperties.lineStyle.linewidth": 1,
      "mainSeriesProperties.lineStyle.priceSource": "close",

      // Area chart style
      "mainSeriesProperties.areaStyle.color1": this.style.down,
      "mainSeriesProperties.areaStyle.color2": this.style.up,
      "mainSeriesProperties.areaStyle.linecolor": this.style.up,
      "mainSeriesProperties.areaStyle.linestyle": 0,
      "mainSeriesProperties.areaStyle.linewidth": 1,
      "mainSeriesProperties.areaStyle.priceSource": "close",
    };
  },
};
export default data.obj();
